import { ArrowRight, Star } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";

export const Hero = () => {
  return (
    <section className="pt-32 pb-20 px-4">
      <div className="container mx-auto text-center max-w-4xl">
        <h1 className="text-4xl md:text-6xl font-bold text-sage-900 mb-6">
          Generate Bulk Alt Text & Image Descriptions in Seconds
        </h1>
        <p className="text-xl text-sage-600 mb-8 max-w-2xl mx-auto">
          Transform your images with AI-powered, SEO-friendly alt text that improves accessibility and search rankings.
        </p>
        <Link to="/auth">
          <Button size="lg" className="animate-fadeIn">
            Start Generating Alt Text
            <ArrowRight className="ml-2" />
          </Button>
        </Link>
        
        <div className="mt-12 flex justify-center items-center gap-8 flex-wrap">
          <div className="flex items-center gap-2">
            <Star className="text-yellow-400" />
            <span className="text-sage-600">4.9/5 Rating</span>
          </div>
          <div className="text-sage-600">1000+ Happy Users</div>
          <div className="text-sage-600">50,000+ Alt Tags Generated</div>
        </div>
      </div>
    </section>
  );
};